import React from "react";
import MalaysiaReqMain from "./MalaysiaReqMain";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const MalaysiaReq = () => {
  return (
    <div className="uaeReqContainer">
      <MalaysiaReqMain />
    </div>
  );
};

export default MalaysiaReq;
